import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IMedico } from '../../models/doctor';
import { DoctorService } from '../../services/doctor.service';

@Component({
  selector: 'app-list-doctors',
  templateUrl: './list-doctors.component.html',
  styleUrls: ['./list-doctors.component.scss']
})
export class ListDoctorsComponent {
  ERoleAdminString = ERoleAdminString;
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() doctors: IMedico[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly doctorService: DoctorService,
    private readonly toastService: ToastService
  ) {}

  public toogleMedicoStatus(medicoId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} o Atendente?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.doctorService.desativarMedico(medicoId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.doctorService.ativarMedico(medicoId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }
}
